import { HelpButton } from "@certn/auth";
import { BasicButton, PrimaryTopNav } from "@certn/cascadia-react";
import { useState } from "react";
import { Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useInformationRequestSaves } from "./InformationRequestSaves";
import { AppLogo } from "../../components/app-header/AppLogo";

export function InformationRequestHeader() {
  const navigate = useNavigate();
  const { waitForSaves } = useInformationRequestSaves();
  const [isSaving, setIsSaving] = useState(false);

  const handleSaveAndExit = async () => {
    setIsSaving(true);
    const saved = await waitForSaves();
    setIsSaving(false);
    if (saved) {
      navigate("/");
    }
  };

  return (
    <PrimaryTopNav
      testID="information-request-top-nav"
      logo={<AppLogo />}
      onLogoPress={handleSaveAndExit}
    >
      <HelpButton />
      <BasicButton
        size="medium"
        testID="information-request-save-and-exit-button"
        isLoading={isSaving}
        onPress={handleSaveAndExit}
      >
        <Trans>Save & exit</Trans>
      </BasicButton>
    </PrimaryTopNav>
  );
}
